import { jsx as _jsx } from "react/jsx-runtime";
import { ConfigureAiBadge } from '@modules/ai/common/badge/configure-ai-badge';
import { ConfigurationBadge } from '../badges/configuration-badge';
import { EnableForUsersPopupMessage } from '../popup-message-content';
import { EnableForOrganizationPopupMessage } from '../popup-message-content/enable-for-organization-popup-message';
export function ConfigurationRequiredBadge({ constituentName, perProfileConfiguration, variant }) {
    if (constituentName === 'AI Enterprise') {
        return _jsx(ConfigureAiBadge, {});
    }
    switch (variant) {
        case 'ENABLE_FOR_ORGANIZATION':
            return (_jsx(ConfigurationBadge, { tooltipContent: _jsx(EnableForOrganizationPopupMessage, { constituentName: constituentName, perProfileConfiguration: perProfileConfiguration }), tooltipTitle: `To enable ${constituentName}` }));
        case 'ENABLE_FOR_USERS':
            return (_jsx(ConfigurationBadge, { tooltipContent: _jsx(EnableForUsersPopupMessage, { constituentName: constituentName }), tooltipTitle: `To enable ${constituentName}` }));
        default:
            return undefined;
    }
}
